module.exports = __webpack_public_path__ + "static/img/partner-logo13.525c9223.png";